export default {
    countryPill: {
        ariaLabel: 'Država: {country}',
    },
}
